var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 368.5 368.5",
    style: {
      enableBackground: "new 0 0 368.5 368.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#60636A;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_324_",
    className: "st0",
    d: "M184.3,0.1c24.7,0,49.4,0,74.1-0.1c3,0,5.1,0.8,7.2,3c33.1,33.3,66.4,66.5,99.6,99.6 c2.2,2.2,3.2,4.5,3.2,7.6c-0.1,49.3-0.1,98.5,0,147.8c0,3.2-0.9,5.4-3.2,7.6c-33.3,33.1-66.5,66.4-99.6,99.6 c-2.2,2.2-4.4,3.2-7.6,3.2c-49.3-0.1-98.5-0.1-147.8,0c-3.2,0-5.4-1-7.6-3.2c-33.2-33.4-66.5-66.8-99.9-100.1c-2-2-2.8-4.1-2.8-6.9 c0.1-49.4,0.1-98.8,0-148.3c0-3,0.9-5.1,3-7.2c33.2-33.2,66.4-66.4,99.5-99.7c2.2-2.2,4.4-3.2,7.6-3.1 C134.9,0.1,159.6,0.1,184.3,0.1z M337.8,184.3c0-20.6,0-41.1,0-61.7c0-2.8-0.6-4.8-2.7-6.9c-27.6-27.5-55.2-55.1-82.7-82.7 c-1.9-1.9-3.7-2.7-6.4-2.7c-41.1,0.1-82.3,0.1-123.4,0c-2.9,0-4.8,0.9-6.8,2.9c-27.4,27.5-54.9,55-82.4,82.4c-2,2-2.9,3.9-2.9,6.8 c0.1,41.1,0.1,82.3,0,123.4c0,2.8,0.8,4.8,2.8,6.9c27.6,27.5,55.2,55.1,82.7,82.7c2,2,4,2.8,6.8,2.8c40.8-0.1,81.7-0.1,122.5,0 c3,0,5.1-0.8,7.2-3c27.4-27.5,54.8-55,82.4-82.4c2.2-2.2,2.9-4.3,2.9-7.3C337.7,225.1,337.8,204.7,337.8,184.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_268_",
    className: "st0",
    d: "M169.3,76.4c0.6-0.1,1.4-0.3,2.1-0.3c9.2,0,18.4,0,27.5,0c1.1,3.5,1.3,125.4,0.3,130.8 c-9.8,0-19.7,0-29.6,0C168.4,203.7,168.1,82.1,169.3,76.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_267_",
    className: "st0",
    d: "M184.2,280.1c-10.2,0-18.5-8.3-18.3-18.4c0.2-10.8,8.5-18,18.2-18.1 c9.8-0.1,18.3,7.7,18.2,18.5C202.4,272,194.1,280.1,184.2,280.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBan);
export default __webpack_public_path__ + "static/media/ban.a06d63480145706203a9686eab8b42b7.svg";
export { ForwardRef as ReactComponent };